export default {"src":"/_next/static/media/xpress-form-icon.38a4a713.svg","height":44,"width":45,"blurWidth":0,"blurHeight":0};